import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=2d86158b&scoped=true&"
import script from "./FaqModal.vue?vue&type=script&lang=js&"
export * from "./FaqModal.vue?vue&type=script&lang=js&"
import style0 from "./FaqModal.vue?vue&type=style&index=0&id=2d86158b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86158b",
  null
  
)

component.options.__file = "FaqModal.vue"
export default component.exports